import styled from 'styled-components'

//
// import {
//   CLICKABLE_COLOR,
//   TEXT_GREY,
//   FONT_BASE_COLOR,
//   FOOTER_MAIN_BG_COLOR,
// } from '@CSSVars/colors'


export const _AppModalPageOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: white;
  top: 0;
  z-index: 10000;

  backface-visibility: hidden;
`

export const _AppModalPageContent = styled.div`
  height: 100%;
  overflow-y: scroll;
`
